import { cond, equals } from 'ramda';
import { FACEBOOK, TWITTER, LINKEDIN, EMAIL } from './shareModal.constants';

export const generateLinkForShareOnSocial = (basicLink, platformName) => {
  const note = '';
  const facebook = `https://www.facebook.com/sharer/sharer.php?u=${basicLink}`;
  const twitter = `https://twitter.com/share?url=${basicLink}`;
  const linkedIn = `https://www.linkedin.com/shareArticle?mini=true&url=${basicLink}&title=&summary=${note}&source=`;
  const mail = `mailto:info@example.com?&subject=&body=${basicLink} ${note}`;

  return cond([
    [equals(FACEBOOK), () => facebook],
    [equals(TWITTER), () => twitter],
    [equals(LINKEDIN), () => linkedIn],
    [equals(EMAIL), () => mail],
  ])(platformName);
};
